var _jsxFileName = "/repo/packages/webassets/src/components/Footer/BillingAddress/BillingAddress.tsx",
  _this = this;
import React from 'react';
import { InlineList, InlineListItem } from '../InlineList';
var BillingAddress = function BillingAddress(_ref) {
  var _ref$country = _ref.country,
    country = _ref$country === void 0 ? 'US' : _ref$country;
  return /*#__PURE__*/React.createElement(InlineList, {
    noMargin: true,
    "data-testid": "BillingAddress__Footer",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 3
    }
  }, country === 'US' ? /*#__PURE__*/React.createElement(InlineListItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, "SurveyMonkey 3050 South Delaware Street, San Mateo, CA, 94403, USA") : country === 'BR' ? /*#__PURE__*/React.createElement(InlineListItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, "SurveyMonkey Brasil Internet Ltda. Rua Joaquim Floriano, N\xBA 243, Su\xEDte 113, Itaim Bibi, S\xE3o Paulo, SP, CEP 04534-010, Brasil") : /*#__PURE__*/React.createElement(InlineListItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }, "SurveyMonkey Europe UC 2 Shelbourne Buildings, 2nd Floor, Shelbourne Road, Ballsbridge, Dublin 4, Ireland"));
};
export default BillingAddress;
//# sourceMappingURL=BillingAddress.js.map